module.exports = __webpack_public_path__ + "img/success.4c70192c.png";